import { EMAIL_FIELD_EMPTY_LABEL, EMAIL_FIELD_VALIDATION_LABEL, FIRST_NAME_ERROR, MOBILE_ERROR, OTP_VERIFY_FIELD_LABEL, } from '../components/ChatComponent/SmartChat/Constants';
export var trimPhoneNumber = function (phoneNumber) { return phoneNumber.split(' ').join(''); };
export var validateInput = function (values, showEmail) {
    var errors = {};
    if (!values.firstName) {
        errors.firstName = FIRST_NAME_ERROR;
    }
    if (!values.phoneNumber || !trimPhoneNumber(values.phoneNumber).match(/^0?4\d{8}$/)) {
        errors.phoneNumber = MOBILE_ERROR;
    }
    if (showEmail &&
        (!values.email ||
            !String(values.email)
                .toLowerCase()
                .match(/^((?!.*#)([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))) {
        errors.email = values.email ? EMAIL_FIELD_VALIDATION_LABEL : EMAIL_FIELD_EMPTY_LABEL;
    }
    return errors;
};
export var validateOtpInput = function (values, wrongNumberClicked) {
    var errors = {};
    if (!wrongNumberClicked && (!values.code || values.code.length !== 6)) {
        errors.code = OTP_VERIFY_FIELD_LABEL;
    }
    return errors;
};
//# sourceMappingURL=validateInput.js.map